// Shared by every caller of the free-text address routes
// (/address_validation/parseAndValidateAddress and /getParsedAddress).
//
// Under the back office, text the server cannot parse into fields comes back
// as ``{_unparseable: true, _note}`` -- NOT the ``_fallback`` shape, which
// carries the whole string in ``street_and_number``. Callers must never save
// the typed text as an address in that case; they show this message.
export const UNPARSEABLE_ADDRESS_MESSAGE =
  "Can't read that address. Enter street, city, state and ZIP.";

export function isUnparseableAddress(data) {
  return !!data && data._unparseable === true;
}

export function unparseableAddressMessage(data) {
  return (data && data._note) || UNPARSEABLE_ADDRESS_MESSAGE;
}
